import PageMeta from 'app/components/common/PageMeta';
import Header from 'app/components/header/Header';
import MarginGroup from 'app/components/layout/MarginGroup';
import MarketPage from 'app/components/layout/MarketPage';
import { PAGE_WIDE_STYLE } from 'app/components/layout/Page';
import PageContent from 'app/components/presentation/containers/page/PageContent';
import PageHeader from 'app/components/presentation/containers/page/PageHeader';
import PublishedLessonNavigation from 'app/components/publishedLesson/PublishedLessonNavigation';
import ScrollPositioner from 'app/components/scroll/ScrollPositioner';
import { useClasses } from 'app/utils/css';
import { ExtractProps } from 'app/utils/types';
import React, { ReactNode, FC } from 'react';

const PageWrapper: FC<{
  children: ReactNode;
  description?: string;
  embedInContentVideos?: boolean;
  header?: string;
  title?: string;
  noIndex?: ExtractProps<typeof PageMeta>['noIndex'];
}> = ({ children, description, embedInContentVideos = false, header, title, noIndex }) => {
  const classes = useStyles();
  return (
    <MarketPage
      description={description}
      noIndex={noIndex}
      header={
        <Header
          embedInContentVideos={embedInContentVideos}
          showTeacherIndicator
          stickies={<PublishedLessonNavigation />}
        />
      }
      title={title}
      variant={PAGE_WIDE_STYLE}
    >
      <ScrollPositioner />
      <main id="content" className={classes.content}>
        <PageContent maxWidth="1200px">
          <MarginGroup margin="15px">
            <PageHeader header={header}>{children}</PageHeader>
          </MarginGroup>
        </PageContent>
      </main>
    </MarketPage>
  );
};

const useStyles = () =>
  useClasses({
    content: {
      minHeight: '100vh',
    },
  });

export default PageWrapper;
